module.exports = __webpack_public_path__ + "assets/img/1_1719_big.e52afabf.jpg";